import { render, staticRenderFns } from "./insuredManagementDetails.vue?vue&type=template&id=45cdd450&scoped=true"
import script from "./insuredManagementDetails.vue?vue&type=script&lang=js"
export * from "./insuredManagementDetails.vue?vue&type=script&lang=js"
import style0 from "./insuredManagementDetails.vue?vue&type=style&index=0&id=45cdd450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45cdd450",
  null
  
)

export default component.exports